function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgGentoo(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#0B0B0B",
    d: "M83.431 40.75s-9.75-24.625-31-27.875S20.25 25.792 20.306 30.75c.047 4.167.125 11.75 13.375 16.375-13.375 15.375-19.282 22-13.391 29.25S47.526 91.364 80.431 57.75c8.402-8.583 3-17 3-17zm-26.092-4.372c-1.038 1.989-4.509 2.229-7.753.536-3.244-1.693-5.032-4.678-3.994-6.667 1.038-1.989 4.509-2.229 7.753-.536 3.244 1.693 5.032 4.677 3.994 6.667z"
  }));
}

SvgGentoo.clsName = 'icon-www__gentoo';
SvgGentoo.remarkName = 'unknown';
export default SvgGentoo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Gentoo.js
// module id = 2349
// module chunks = 17 18